webpackJsonp([0],{

/***/ 1159:
/*!************************************************************!*\
  !*** ./screens/SplatRouter/screens/BasicPage/fragments.js ***!
  \************************************************************/
/*! exports provided: basicPageFragment */
/*! exports used: basicPageFragment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basicPageFragment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject = _taggedTemplateLiteral(['\n  fragment BasicPageFragment on NodePage {\n    title\n    body {\n      value\n    }\n  }\n'], ['\n  fragment BasicPageFragment on NodePage {\n    title\n    body {\n      value\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



var basicPageFragment = __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),

/***/ 1160:
/*!********************************************************!*\
  !*** ./screens/SplatRouter/screens/BasicPage/index.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(/*! react-helmet */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(/*! utils */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Header__ = __webpack_require__(/*! Header */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Menu__ = __webpack_require__(/*! Menu */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Footer__ = __webpack_require__(/*! Footer */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css__ = __webpack_require__(/*! ./styles.css */ 1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_css__);








var BasicPage = function BasicPage(_ref) {
  var title = _ref.title,
      body = _ref.body;

  // Format body to:
  // - Update inline image src to include full url
  // - Remove all links
  var formattedBody = body.value;
  formattedBody = formattedBody ? formattedBody.replace('src="/sites/default/files/inline-images/', 'src="https://backend2019.texascamp.org/sites/default/files/inline-images/') : '';
  var backgroundImage = void 0;
  switch (title) {
    case 'About Us':
      backgroundImage = 'camper';
      break;
    case 'Code of Conduct':
      backgroundImage = 'watertower';
      break;
    case 'Getting Around':
      backgroundImage = 'alamo';
      break;
    case 'Program':
      backgroundImage = 'camper';
      break;
    case 'Visiting San Antonio':
      backgroundImage = 'alamo';
      break;
    default:
      backgroundImage = 'snake';
      break;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a, { title: title }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Menu__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6__styles_css___default.a.contentWrapper },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Header__["a" /* default */], { image: backgroundImage }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6__styles_css___default.a.content },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: __WEBPACK_IMPORTED_MODULE_6__styles_css___default.a.title },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__styles_css___default.a.detail },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_css___default.a.mainContent },
            Object(__WEBPACK_IMPORTED_MODULE_2_utils__["a" /* cleanHtml */])(formattedBody)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Footer__["a" /* default */], null)
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BasicPage);

/***/ }),

/***/ 1161:
/*!**********************************************************!*\
  !*** ./screens/SplatRouter/screens/BasicPage/styles.css ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--1Cmny","content":"content--3cSx_ contentWrapper--AHarZ","title":"title--175-a title--3f9JQ","detail":"detail--LioaV contentArea--SiMDT","mainContent":"mainContent--30qG4"};

/***/ }),

/***/ 548:
/*!******************************************!*\
  !*** ./screens/SplatRouter/component.js ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(/*! react-apollo */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_BasicPage_fragments__ = __webpack_require__(/*! BasicPage/fragments */ 1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_BasicPage__ = __webpack_require__(/*! BasicPage */ 1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_NotFound__ = __webpack_require__(/*! NotFound */ 168);
var _templateObject = _taggedTemplateLiteral(['\n  query SplatRouterQuery($path: String!) {\n    route(path: $path) {\n      entity {\n        ...BasicPageFragment\n      }\n    }\n  }\n\n  ', '\n'], ['\n  query SplatRouterQuery($path: String!) {\n    route(path: $path) {\n      entity {\n        ...BasicPageFragment\n      }\n    }\n  }\n\n  ', '\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var SplatRouter = function SplatRouter(_ref) {
  var entity = _ref.entity,
      loading = _ref.loading;

  if (loading) {
    return null;
  }

  switch (entity && entity.__typename) {// eslint-disable-line no-underscore-dangle
    case 'NodePage':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_BasicPage__["a" /* default */], entity);

    default:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_NotFound__["a" /* default */], null);
  }
};

var query = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_3_BasicPage_fragments__["a" /* basicPageFragment */]);

var withQuery = Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["graphql"])(query, {
  options: function options(props) {
    return {
      variables: {
        // Default to the front page when no path suffix was given.
        path: props.match.url
      }
    };
  },
  props: function props(_ref2) {
    var _ref2$data = _ref2.data,
        route = _ref2$data.route,
        loading = _ref2$data.loading;
    return {
      entity: route && route.entity,
      loading: loading
    };
  }
});

/* harmony default export */ __webpack_exports__["default"] = (withQuery(SplatRouter));

/***/ })

});


// WEBPACK FOOTER //
// SplatRouter/component.82c1773710a426c93df6.js